import { Accordion, AccordionDetails, AccordionSummary, Box, Button, FormControl, FormControlLabel, FormHelperText, Grid, Paper, Switch, TextField, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import errorFormat from '../../../../../utils/errorFormat';
import configSiteUrls from '../../../configs/configSiteUrls';

import { useAddCentroApoioAnexosMutation } from '../centroApoioAnexoApiSlice';
import { useAddCentroApoioMutation } from '../centroApoioApiSlice';
import { IScentroApoio, IScentroApoioLoginResponse, CentroApoio, CentroApoioDTO, CentroApoioLoginResponse } from '../types/CentroApoio';
import { TxtSexo } from '../../../../../components/formControls/TxtSexo';

import { TxtDocumentoCPFCNPJ } from '../../../../../components/formControls/TxtDocumentoCPFCNPJ';
import { TxtTelefone } from '../../../../../components/formControls/TxtTelefone';
import { GridExpandMoreIcon } from '@mui/x-data-grid';
import GeralAnexosUpload from '../../licitacao/create/GeralAnexosUpload';
import convertImageToWeb from '../../../../../utils/convertImageToWeb';

export const CentroApoioCreate = () => {
  const [centroApoio, SetCentroApoio] = useState<CentroApoio>(IScentroApoio);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [createCentroApoio, status] = useAddCentroApoioMutation();

  const [createAnexos, statusCreateAnexos] = useAddCentroApoioAnexosMutation();
  const [centroApoioAnexoParaSalvar, setCentroApoioAnexoParaSalvar] = useState<File[]>([]);
  const [centroApoioLoginResponse, setCentroApoioLoginResponse] = useState<CentroApoioLoginResponse>(IScentroApoioLoginResponse);
  const [showLoginInfo, setShowLoginInfo] = useState(false);

  const handleFileAnexoChange = async (files: File[]) => {
    const convertedFiles = await Promise.all(files.map(file => convertImageToWeb(file)));
    setCentroApoioAnexoParaSalvar(prev => [...prev, ...convertedFiles]);
  };
  const handleOnDeleteParaSalvar = (index: number) => {
    setCentroApoioAnexoParaSalvar(prev => prev.filter((_, i) => i !== index));
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const cursorPosition = e.target.selectionStart;

    if (name === 'exercicio') {
      // Só números
      const somenteNumeros = value.replace(/\D/g, '').slice(0, 4);

      SetCentroApoio(prev => ({
        ...prev,
        exercicio: somenteNumeros === '' ? null : Number(somenteNumeros)
      }));

      e.target.value = somenteNumeros;

      // Mantém o cursor no local correto
      setTimeout(() => {
        e.target.setSelectionRange(cursorPosition, cursorPosition);
      }, 0);

      return;
    }

    // Demais campos
    SetCentroApoio(prev => ({
      ...prev,
      [name]: value
    }));

    // Aguarde até que o DOM seja atualizado
    setTimeout(() => {
      const input = e.target;
      input.setSelectionRange(cursorPosition, cursorPosition);
    }, 0);
  };

  const handleChangeSexo = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    SetCentroApoio(prev => ({
      ...prev,
      sexo: e.target.value
    }));
  };

 

  const handleExcluirTodosAnexos = () => {
    setCentroApoioAnexoParaSalvar([]);
  };

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (!centroApoio.anonimo) {
      if (centroApoio.documento === null) {
        enqueueSnackbar('O campo Documento é obrigatório.', { variant: 'warning' });
        return;
      }

      if (!centroApoio.nome) {
        enqueueSnackbar('O Nome deve ser informado!', { variant: 'warning' });
        return;
      }

      if (!centroApoio.email) {
        enqueueSnackbar('O Email deve ser informado!', { variant: 'warning' });
        return;
      }
      if (!centroApoio.telefone) {
        enqueueSnackbar('O Telefone deve ser informado!', { variant: 'warning' });
        return;
      }
    }
 
    if (!centroApoio.observacao) {
      enqueueSnackbar('A Observação deve ser informada!', { variant: 'warning' });
      return;
    }


    const parms: CentroApoioDTO = {
      id: centroApoio.id || '',
      idCategoria: centroApoio.categoria || '',
      nome: centroApoio.nome || '',
      documento: centroApoio.documento || '',
      email: centroApoio.email || '',
      sexo: centroApoio.sexo || '',
      telefone: centroApoio.telefone || '',
      formatoContato: centroApoio.formatoContato || '',
      observacao: centroApoio.observacao || '',
      anonimo: centroApoio.anonimo || false
    };

    setLoading(true);
    const result: any = await createCentroApoio(parms);
    const dataCentroApoio = result?.data;
    const idCentroApoio = dataCentroApoio?.id;

    if (idCentroApoio) {
      setCentroApoioLoginResponse(dataCentroApoio); // armazena login e senha no estado
      setShowLoginInfo(true); // mostra a div de confirmação

      if (centroApoioAnexoParaSalvar.length) {
        const formData = new FormData();
        centroApoioAnexoParaSalvar.forEach(file => formData.append('imagens', file));
        formData.append('centroApoioID', idCentroApoio);
        createAnexos(formData);
      }
      handleExcluirTodosAnexos();
      //navigate(configSiteUrls.SITE_CENTRO_APOIO_T);
    }
    setLoading(false);
  }

  useEffect(() => {
    if (status.isError) {
      enqueueSnackbar('Registro não incluído!', { variant: 'error' });
      const erroReturn: string = errorFormat(status);
      enqueueSnackbar(erroReturn, { variant: 'error' });
    }

    if (status.isSuccess) {
      enqueueSnackbar('Registro incluído!', { variant: 'success' });
      // navigate(-1);
      // setGrupo(ISgrupo);
    }
  }, [status]);

  return (
    <>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          mt: 4
        }}
      >    
        <Paper
          elevation={3}
          sx={{
            width: { xs: '100%', sm: '90%', md: '90%', lg: '90%' },
            maxWidth: '1200px',
            p: 3
          }}
        >
          {showLoginInfo && centroApoioLoginResponse?.login && centroApoioLoginResponse?.senha ? (
            <>
              <Paper elevation={0} sx={{ mt: 4, p: 3, textAlign: 'center' }}>
                <Typography variant="h6" gutterBottom>
                  Sua solicitação foi enviada com sucesso! Guarde o login e a senha abaixo para consultar o andamento sempre que precisar:
                </Typography>
                <Typography variant="body1">
                  <strong>Login:</strong> {centroApoioLoginResponse.login}
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <strong>Senha:</strong> {centroApoioLoginResponse.senha}
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setShowLoginInfo(false); // esconde a div se quiser permitir nova submissão
                    navigate(configSiteUrls.SITE_CENTRO_APOIO_PUBLIC_MENU); // ou qualquer outra ação
                  }}
                >
                  Voltar
                </Button>
              </Paper>
            </>
          ) : (
            <>
              <Typography variant="h6" component="h1" sx={{ mb: 2 }}>
                Preencha o formulário para criar uma nova solicitação na Centro Apoio
              </Typography>

              <form onSubmit={handleSubmit} method="POST">
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6} lg={4}>
                    <TxtDocumentoCPFCNPJ
                      value={centroApoio.documento || ''}
                      onChange={val => SetCentroApoio(prev => ({ ...prev, documento: val }))}
                      disabled={centroApoio.anonimo}
                      required={!centroApoio.anonimo}
                    />
                  </Grid>

                  {/* Nome */}
                  <Grid item xs={12}>
                    <FormControl fullWidth>
                      <TextField
                        disabled={centroApoio.anonimo}
                        required={!centroApoio.anonimo}
                        label="Nome"
                        name="nome"
                        onChange={handleChange}
                        size="small"
                        inputProps={{ maxLength: 50 }}
                        value={centroApoio.nome}
                      />
                      <FormHelperText>{centroApoio.nome?.length}/50 caracteres</FormHelperText>
                    </FormControl>
                  </Grid>

                  {/* Email */}
                  <Grid item xs={12}>
                    <FormControl fullWidth>
                      <TextField
                        disabled={centroApoio.anonimo}
                        required={!centroApoio.anonimo}
                        label="E-mail"
                        name="email"
                        onChange={handleChange}
                        size="small"
                        inputProps={{ maxLength: 50 }}
                        value={centroApoio.email}
                      />
                      <FormHelperText>{centroApoio.email?.length}/50 caracteres</FormHelperText>
                    </FormControl>
                  </Grid>

                  {/* Sexo */}
                  <Grid item xs={12} sm={6}>
                    <TxtSexo
                      disabled={centroApoio.anonimo}
                      required={!centroApoio.anonimo}
                      value={centroApoio.sexo}
                      onChange={handleChangeSexo}
                      helperText={`${centroApoio.sexo?.length ?? 0}/50 caracteres`}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TxtTelefone
                      value={centroApoio.telefone || ''}
                      onChange={val => SetCentroApoio(prev => ({ ...prev, telefone: val }))}
                      disabled={centroApoio.anonimo}
                      required={!centroApoio.anonimo}
                    />
                  </Grid>

                  {/* Observação */}
                  <Grid item xs={12}>
                    <FormControl fullWidth>
                      <TextField
                        required
                        label="Observação"
                        name="observacao"
                        onChange={handleChange}
                        size="small"
                        multiline
                        rows={4}
                        inputProps={{ maxLength: 1000 }}
                        value={centroApoio.observacao}
                      />
                      <FormHelperText>{centroApoio.observacao?.length}/1000 caracteres</FormHelperText>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12}>
                    <Box>
                      <Accordion defaultExpanded={false}>
                        <AccordionSummary expandIcon={<GridExpandMoreIcon />} aria-controls="panel2-content" id="panel4-header">
                          <Typography color="secondary" variant="body1" gutterBottom>
                            Currículo
                          </Typography>
                        </AccordionSummary>

                        <AccordionDetails>
                          <Paper>
                            <GeralAnexosUpload
                              arquivosSalvos={null}
                              arquivosParaSalvar={centroApoioAnexoParaSalvar}
                              onFileChange={handleFileAnexoChange}
                              onDeleteParaSalvar={handleOnDeleteParaSalvar}
                              onDeleteAll={handleExcluirTodosAnexos}
                              tipo="CENTRO_APOIO"
                              multiple={false}
                            />
                          </Paper>
                        </AccordionDetails>
                      </Accordion>
                    </Box>
                  </Grid>

                  {/* Botões */}
                  <Grid item xs={12}>
                    <Box display="flex" gap={2}>
                      <Button type="submit" variant="contained" color="secondary">
                        Gravar
                      </Button>

                      <Button variant="contained" color="primary" onClick={() => navigate(configSiteUrls.SITE_CENTRO_APOIO_PUBLIC_MENU)}>
                        Voltar
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </form>
            </>
          )}
        </Paper>
      </Box>
    </>
  );
};
